import { z } from 'zod';
import { IndicatorType } from '@shared/types';
import { ZigZagInputSchema } from './zig-zag.schema';

export const MarketStructureInputSchema = z.object({
  type: z.literal(IndicatorType.MARKET_STRUCTURE),
  zigZag: ZigZagInputSchema
});

export type MarketStructureInput = z.infer<typeof MarketStructureInputSchema>;
